export const _create_options = [
  { opt: "Individual" },
  { opt: "Position/Management Level" },
  // { opt: "Groups" },
];
